<h2 mat-dialog-title>{{'core.terms_of_use.title' | translate}}</h2>

<mat-dialog-content>
  <div class="term-content" [innerHTML]="data.termContent"></div>
  <p> {{'core.terms_of_use.version' | translate}} : <strong> {{ data.termVersion }}</strong></p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="decline()">{{'core.terms_of_use.decline' | translate}}</button>
  <button mat-raised-button color="primary" (click)="accept()">{{'core.terms_of_use.accept' | translate}}</button>
</mat-dialog-actions>
